export default {
  setCalls: (state, calls) => (state.calls = calls),
  setUser: (state, user) => (state.user = user),
  setProject: (state, project) => (state.project = project),
  setMessage: (state, { message, color = "info" }) =>
    (state.message = { message, color }),
  setLoadingPage: (state, loading) => (state.loadingPage = loading),
  setAccountBalance: (state, balance) => (state.accountBalance = balance),
  setWeekStats: (state, weekStats) => (state.weekStats = weekStats)
};
